import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AeHblListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    isClosed: boolean|null = null;
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    postDate: string = '';
    hawbNo: string = '';
    branch: string = '';
    refNo: string = '';
    agentName: string = '';
    mawbNo: string = '';
    soNo: string = '';
    projectNo: string = '';
    shipmentId: string = '';
    blDate: string | null = null;
    fromBlDate: string | null = null;
    toBlDate: string | null = null;
    fltNo: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    hEtd: string | null = null;
    fromHEtd: string | null = null;
    toHEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    lCode: string = '';
    dCode: string = '';
    shipper: string = '';
    shipperName: string | null = null;
    lcNo: string = '';
    consignee: number = 0;
    consigneeName: string | null = null;
    cName: string = '';
    notify: number = 0;
    notifyName: string | null = null;
    nName: string = '';
    customer: number|null = null;
    custSName: string = '';
    credit: string = '';
    paidStat: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    toPaidDate: string | null = null;
    issuedBy: string = '';
    expRefNo: string = '';
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    chgKgs: number|null = null;
    fromChgKgs: number|null = null;
    toChgKgs: number|null = null;
    chgLbs: number|null = null;
    fromChgLbs: number|null = null;
    toChgLbs: number|null = null;
    pimsLinkId: number = 0;
    u1ID: string = '';
    u1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    aeMblId: number = 0;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;
    acctCloseBy: string = '';
    acctCloseDate: string | null = null;
    pCloseDate: string | null = null;
    autoOpCloseBy: string = '';
    opCloseBy: string = '';
    opCloseDate: string | null = null;
    recognized: string = '';
    status: string = '';
    blType: string = '';
    custRefNo: string = '';
    salesperson: string = '';
    commodity: string = '';
    issuingCarrier: string = '';
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 35, text: 'D/ID', width: 35, dataIndex: 'shipmentType', noNullOrEmptySearch: true,}),
        
        // XCol.Create({ col: 6, text: 'B/L Type', width: 80, dataIndex: 'blType', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'HAWB', width: 100, dataIndex: 'hawbNo'}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 6, text: 'MAWB', width: 100, dataIndex: 'mawbNo'}),
        XCol.Create({ col: 7, text: 'S/O', width: 80, dataIndex: 'soNo'}),
        XCol.Create({ col: 8, text: 'Project ID', width: 80, dataIndex: 'projectNo'}),
        XCol.Create({ col: 9, text: 'B/L Date', width: 75, dataIndex: 'blDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Flight', width: 60, dataIndex: 'fltNo'}),
        XCol.Create({ col: 11, text: 'M.ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'ETD', width: 75, dataIndex: 'hEtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'Departure', width: 60, dataIndex: 'lCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Destination', width: 60, dataIndex: 'dCode', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 16, text: 'Shipper', width: 120, dataIndex: 'shipperName', hasCustomTooltip:true}),
        XCol.Create({ col: 17, text: 'L/C', width: 100, dataIndex: 'lcNo', visible: false}),
        XCol.Create({ col: 18, text: 'Consignee', width: 120, dataIndex: 'consigneeName', hasCustomTooltip:true}),
        XCol.Create({ col: 19, text: 'Notify', width: 120, dataIndex: 'notifyName', hasCustomTooltip:true}),
        XCol.Create({ col: 20, text: 'Customer', width: 120, dataIndex: 'custSName'}),
        //XCol.Create({ col: 13, text: 'Cust. Ref. No', width: 100, dataIndex: 'custRefNo'}),
        XCol.Create({ col: 21, text: 'Issuer', width: 120, dataIndex: 'issuingCarrier'}),
        XCol.Create({ col: 22, text: 'Credit', width: 60, dataIndex: 'credit', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 23, text: 'P', width: 40, dataIndex: 'paidStat'}),
        XCol.Create({ col: 24, text: 'Paid Date', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 25, text: 'Issued by', width: 80, dataIndex: 'issuedBy'}),
        XCol.Create({ col: 26, text: 'Export Ref.', width: 100, dataIndex: 'expRefNo'}),
        XCol.Create({ col: 27, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
        XCol.Create({ col: 28, text: 'PKG(s)', width: 80, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 29, text: 'KGS', width: 80, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 30, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 31, text: 'CHRG KGS', width: 80, dataIndex: 'chgKgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 32, text: 'CHRG LBS', width: 80, dataIndex: 'chgLbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 33, text: 'Sales', width: 80, dataIndex: 'salesperson'}),
        
        XCol.Create({ col: 36, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 37, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 38, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        
        XCol.Create({ col: 39, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 40, text: 'Create by', width: 100, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 41, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 42, text: 'Update by', width: 100, dataIndex: 'u2ID', visible: false}),

        //for use tooltip
        XCol.Create({ col: 43, text: '', width: 0, dataIndex: 'shipper', hiddenInColumnSetup: true, visible: false}), 
        XCol.Create({ col: 44, text: '', width: 0, dataIndex: 'cName', hiddenInColumnSetup: true, visible: false}),
        XCol.Create({ col: 45, text: '', width: 0, dataIndex: 'nName', hiddenInColumnSetup: true, visible: false}),
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
      let returnCloumns = _.cloneDeep(this.ExportCollection);
      if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
      return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AeHblListItem.prototype.u1Date, orderByAscending: false };

    public static formatData(data: AeHblListItem[]) {
        return data.map((d: AeHblListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
      blDate: {from: 'fromBlDate', to: 'toBlDate'},
      etd: {from: 'fromEtd', to: 'toEtd'},
      hEtd: {from: 'fromHEtd', to: 'toHEtd'},
      eta: {from: 'fromEta', to: 'toEta'},
      paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
      pkgs: {from: 'fromPkgs', to: 'toPkgs'},
      kgs: {from: 'fromKgs', to: 'toKgs'},
      lbs: {from: 'fromLbs', to: 'toLbs'},
      chgKgs: {from: 'fromChgKgs', to: 'toChgKgs'},
      chgLbs: {from: 'fromChgLbs', to: 'toChgLbs'},
      u1Date: {from: 'fromU1Date', to: 'toU1Date'},
      u2Date: {from: 'fromU2Date', to: 'toU2Date'},
      confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
  }

}
